import { useUserContext } from '@/auth/UserContext';
import { SubscriptionPaymentKind } from '@/types/user';

export const useStatusCard = () => {
  const { user } = useUserContext();
  const { premiumSubscription, userSettings } = user ?? {};

  const isActive = premiumSubscription?.isActive ?? false;
  const isActiveTillEndOfYear =
    premiumSubscription?.isActiveTillEndOfYear ?? false;
  const isSmsSubscriber = userSettings?.isSmsSubscriber ?? false;
  const isCardSubscriber = userSettings?.isRecurringPaymentsEnabled ?? false;
  const endDate = premiumSubscription?.endDate;

  const canPurchase = !(isActive && isActiveTillEndOfYear);
  const showEndDate =
    isActive &&
    !isActiveTillEndOfYear &&
    !!endDate &&
    !isSmsSubscriber &&
    !isCardSubscriber;
  const canCancel = isSmsSubscriber || isCardSubscriber;
  const cancelKind = isSmsSubscriber
    ? SubscriptionPaymentKind.Sms
    : SubscriptionPaymentKind.Card;

  return {
    isActive,
    isSmsSubscriber,
    isCardSubscriber,
    canPurchase,
    showEndDate,
    endDate,
    canCancel,
    cancelKind,
  };
};
